import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBurger: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBurger"><Path d="M12 3C10.5447 3 8.34866 3.40458 6.48269 4.58792C4.56701 5.80279 3 7.84935 3 11H21C21 7.84935 19.433 5.80279 17.5173 4.58792C15.6513 3.40458 13.4553 3 12 3Z" fill="currentColor"/><Path d="M3 21V17H21V21H3Z" fill="currentColor"/><Path d="M22 15V13H2V15H22Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBurger;
